import React, { FC, useState } from 'react';
import { Link, useParams } from 'react-router-dom';
import clsx from 'clsx';
import {
  APPLICATION_DETAILS_NAVIGATION,
  applicationDetailsNavigation,
} from '../../constants/application-details/application-details-navigation';
import { useTranslation } from 'react-i18next';
import { useMerchants } from '../../store/merchnts/merchants-context';
import { useLocation } from 'react-router';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { IModalWindow, ModalWindow } from '../modal/ModalWindow';
import { ApplicationDetailActivityLogsModal } from './ApplicationDetailActivityLogsModal';

export const ApplicationDetailsLayout: FC = () => {
  const { t } = useTranslation();
  const { applicationId } = useParams<{ applicationId: string }>();
  const { pathname, state } = useLocation();

  const { merchantState: { applicationData }} = useMerchants();

  const [modalState, setModalState] = useState<IModalWindow>({
    isOpen: false
  });

  const closeModal = (): void => setModalState(prev => ({ ...prev, isOpen: false }));

  const openModal = (): void => {
    setModalState({
      isOpen: true,
      isRightSideModal: true,
      modalTitle: 'Activity logs',
      contentClassName: 'd-block',
      size: 'md',
      content: <ApplicationDetailActivityLogsModal id={applicationId} />
    });
  };

  return (
    <>
      <div>
        <div className="card mb-5">
          <div className="card-body border-bottom d-flex align-items-center justify-content-between">
            <div className="fw-bolder fs-5 fs-sm-3">{applicationData?.legalEntityName}</div>

            <ButtonComponent
              buttonType={BUTTON_TYPE.FAKE_LINK}
              buttonName="Activity log"
              additionalClass="btn-sm"
              onButtonClick={openModal}
              withoutUnderline
            />
          </div>

          <div className="d-flex align-items-center merchant-navigation px-9">
            {
              applicationDetailsNavigation.map(({ path, text, additionalClass }) => (
                <Link
                  key={path}
                  to={`/accounts/applications/${applicationId}/${path}`}
                  state={{ ...state }}
                  className={clsx(
                    'align-items-center justify-content-center fs-8 fs-sm-7 fw-bolder text-center px-3 h-70px tab-style',
                    additionalClass,
                    pathname.includes(path) ? 'text-danger tab-bgc' : 'text-dark')
                  }
                >
                  {t(text)} {path === APPLICATION_DETAILS_NAVIGATION.DOCUMENTS && applicationData?.uploadedDocuments?.length > 0
                  && <span className="badge bg-primary ms-2">{applicationData?.uploadedDocuments?.length}</span>}
                </Link>
              ))
            }

          </div>
        </div>
      </div>

      <ModalWindow
        {...modalState}
        onClose={closeModal}
      />
    </>
)
  ;
};